export const hiredApplicantsRoute = '/employer/hired/applicants/details/';
export const sendTeamMessageRoute = '/employer/hired/applicants/send_message/';
export const positionApplicantsCountRoute = '/employer/position/applications/get/';
